<footer class="login-footer">
	<div class="login-footer__container">
		<div class="login-footer__row login-footer__row--hot-line">
			<section class="login-footer__hot-line">
				<h2 class="login-footer__hot-line-title">Горячая линия</h2>
				<a
					class="phone-link login-footer__hot-line-phone"
					href="tel:{{ phone }}"
				>
					{{ phone }}
				</a>
			</section>
			<app-sip-phone-call></app-sip-phone-call>
		</div>
		<div class="login-footer__row login-footer__row--app-download-link">
			<!-- <app-app-download title="Мобильные приложения"></app-app-download> -->
		</div>
		<div class="login-footer__row">
			<section class="social">
				<h3 class="social__title">Мы в социальных сетях</h3>
				<ul class="social__list">
					<li class="social__list-item">
						<a
							class="social__list-item-link social__list-item-link--vk"
							href="http://vk.com/rsb"
							target="_blank"
							title="Вконтакте"
						>
							Вконтакте
						</a>
					</li>
					<li class="social__list-item">
						<a
							class="social__list-item-link social__list-item-link--ok"
							href="http://www.ok.ru/rsb"
							target="_blank"
							title="Одноклассники"
						>
							Одноклассники
						</a>
					</li>
					<li class="social__list-item">
						<a
							class="social__list-item-link social__list-item-link--twitter"
							href="http://twitter.com/bank_rs"
							target="_blank"
							title="Twitter"
						>
							Twitter
						</a>
					</li>
					<li class="social__list-item">
						<a
							class="social__list-item-link social__list-item-link--youtube"
							href="http://www.youtube.com/user/russianstandardbank"
							target="_blank"
							title="Youtube"
						>
							Youtube
						</a>
					</li>
				</ul>
			</section>
		</div>
	</div>
</footer>
